import api from './api';

const resource = 'Category/';

export const list = async (query) => {
  return await api.get(resource + 'List?PageSize=1000&' + query);
};

export const getById = async (id) => {
  return await api.get(resource + 'Get?id=' + id);
};

export const upsert = async (body) => {
  return await api.post(resource + 'Upsert', body);
};

export const duplicate = async (id) => {
  return await api.post(resource + 'Duplicate?id=' + id);
};

export const deleteById = async (id) => {
  return await api.delete(resource + 'Delete?id=' + id);
};

export const reorder = async (body) => {
  return await api.post(resource + 'Reorder', body);
};

const categoryApi = { list, getById, upsert, duplicate, deleteById, reorder };

export default categoryApi;
